import { Loader } from 'google-maps';

// const HTML = require('html-parse-stringify2');

import { isElement, isEmpty, stringToHtml } from '../../utils';

let markers = [];

async function initMap() {
	const loader = new Loader('AIzaSyAVjkG12OoimJQSvN2R4__K_1iAEzhu3og', {
		libraries: ['places'],
	});
	const google = await loader.load();

	// var svg = require('../../../Content/Images/icons/map-pin-shape.svg');
	// var dom = HTML.parse(svg);
	// var parser = new DOMParser();
	// var doc = parser.parseFromString(svg, 'image/svg+xml');
	// dom.appendChild(doc.firstElementChild);
	// svg = dom.firstElementChild;
	// let svgHeight = svg.getAttribute('height');

	/** @type {google.maps.Symbol} */
	const svgMarker = {
		path: 'M20.00004,0c11.04609,0,20.02912,6.98188,19.99989,20.56851s-18.33067,29.43149-19.5722,29.43149S-.06139,33.41629,.00015,20.56851C.06169,7.72073,8.95394,0,20.00004,0Z',
		fillColor: '#ff5b00',
		fillOpacity: 1,
		strokeWeight: 0,
		labelOrigin: new google.maps.Point(20, 20),
		scale: 0.7,
		// anchor: new google.maps.Point(
		// 	40, // width
		// 	50 // height
		// ),
	};

	const box = document.getElementById('map');

	let lat, lng;

	if (navigator.geolocation) {
		navigator.geolocation.getCurrentPosition(
			(position) => {
				document.getElementById('locations').classList.add('location-enabled');
				lat = position.coords.latitude;

				lng = position.coords.longitude;

				// let infoWindow = new google.maps.InfoWindow();
				const userLocation = new google.maps.LatLng(lat, lng);
				// var geocoder = new google.maps.Geocoder();

				google.maps.Map.prototype.clearOverlays = function () {
					if (markers != undefined) {
						for (var i = 0; i < markers.length; i++) {
							markers[i].setMap(null);
						}
						markers = new Array();
						markers.length = 0;
					}
				};

				if (userLocation) {
					let map = new google.maps.Map(box, {
						center: userLocation,
						zoom: 10,
					});

					const service = new google.maps.places.PlacesService(map);

					service.nearbySearch(
						{
							location: userLocation,
							keyword: 'MidFirst Bank',
							radius: getMeters(25),
							type: ['bank'],
						},
						(places, status, pagination) => {
							if (status !== 'OK' || !places) {
								console.error(status);
								return;
							}
							/** @type {google.maps.places.PlaceResult[]} searchResultsArray */
							let searchResultsArray = [];
							searchResultsArray.push(...places);

							var moreButton = document.getElementById('more');

							if (moreButton) {
								moreButton.setAttribute('data-page', '1');
							}
							if (pagination && pagination.hasNextPage) {
								pagination.nextPage();
							} else {
								searchResultsArray = paginate(searchResultsArray, 4);
								let page = moreButton.getAttribute('data-page');

								moreButton.onclick = function () {
									let nextPage = parseInt(page) + 1;
									if (searchResultsArray[page] !== undefined) {
										addPlaces(searchResultsArray[page], map);
									}

									if (searchResultsArray[nextPage] === undefined) {
										moreButton.disabled = true;
									} else {
										page++;
										moreButton.setAttribute('data-page', page);
									}
								};

								addPlaces(searchResultsArray[page], map);
							}
						}
					);

					/**
					 * Create places list
					 *
					 * @param {google.maps.places.PlaceResult[]} places
					 * @param {google.maps.Map} map
					 */
					// eslint-disable-next-line
					function addPlaces(places, map) {
						const placesList = document.getElementById('places');
						if (!places) {
							return;
						}

						placesList.innerHTML = '';

						// Clear out the old markers.
						map.clearOverlays();
						// For each place, get the icon, name and location.
						const bounds = new google.maps.LatLngBounds();
						Object.entries(places).forEach((entry) => {
							let [i, place] = entry;

							if (!place.geometry || !place.geometry.location) {
								console.log('Returned place contains no geometry');
								return;
							}

							if (place.geometry.viewport) {
								// Only geocodes have viewport.
								bounds.union(place.geometry.viewport);
							} else {
								bounds.extend(place.geometry.location);
							}

							service.getDetails(
								{
									placeId: place.place_id,
									// fields: ['address_component', 'international_phone_number', 'opening_hours'],
								},
								(placeDetail, status) => {
									if (status == google.maps.places.PlacesServiceStatus.OK) {
										placeListItem(i, placeDetail, placesList, map, bounds, svgMarker);
									}
								}
							);
						});

						map.fitBounds(bounds);
					}

					// Create the search box and link it to the UI element.
					const input = document.getElementById('location-search');
					const searchBox = new google.maps.places.SearchBox(input);

					// Bias the SearchBox results towards current map's viewport.
					map.addListener('bounds_changed', () => {
						searchBox.setBounds(map.getBounds());
					});
				}
			},
			(error) => {
				document.getElementById('locations').classList.add('location-disabled');
				switch (error.code) {
					case error.PERMISSION_DENIED:
						document.getElementById('error-title').innerHTML =
							'You have denied the request for geolocation.';
						document.getElementById('error-text').innerHTML =
							'To find a MidFirst Bank, use the search feature, navigate using the map, or turn on location services.';
						break;
					case error.POSITION_UNAVAILABLE:
						document.getElementById('error-title').innerHTML =
							'We are unable to access your exact location.';
						document.getElementById('error-text').innerHTML =
							// eslint-disable-next-line
							"Something went wrong with your browser's location services";
						break;
					case error.TIMEOUT:
						document.getElementById('error-title').innerHTML =
							'The request to get your location timed out.';
						// eslint-disable-next-line
						document.getElementById('error-text').innerHTML =
							// eslint-disable-next-line
							"Something went wrong with your browser's location services";
						break;
					case error.UNKNOWN_ERROR:
						document.getElementById('error-title').innerHTML = 'An unknown error occurred.';
						document.getElementById('error-text').innerHTML =
							// eslint-disable-next-line
							"Something went wrong with your browser's location services";
						break;
				}
			}
		);
	} else {
		document.getElementById('locations').classList.add('location-disabled');
		document.getElementById('error-title').innerHTML = 'You have denied the request for geolocation.';
		document.getElementById('error-text').innerHTML =
			'To find a MidFirst Bank, use the search feature, navigate using the map, or turn on location services.';
	}
}
function getMeters(miles) {
	return miles * 1609.344;
}
function joinDate(t, a, s) {
	return a
		.map((m) => {
			let f = new Intl.DateTimeFormat('en', m);
			return f.format(t);
		})
		.join(s);
}

/**
 *
 *
 * @param {*} parent
 * @param {*} [children=[]]
 * @returns {HTMLElement}
 */
function appendChildren(parent, children = []) {
	if (typeof parent === 'string') {
		parent = stringToHtml(parent);
	}
	if (isElement(parent)) {
		if (children.length > 0) {
			children.forEach((child) => {
				if (typeof child === 'string') {
					child = stringToHtml(child);
				}

				if (isElement(child)) {
					parent.appendChild(child);
				}
			});
		}
	}

	return parent;
}
/**
 *
 *
 * @param {google.maps.places.PlaceResult} place
 */
function placeStatus(place) {
	if (!place.opening_hours) return;
	let statusText = 'Open';

	let statusClass = 'is-open';

	if (!place.opening_hours.isOpen()) {
		statusClass = 'is-closed';
		const d = new Date();

		let weekday = d.getDay();
		let periods = place.opening_hours.periods;
		if (Array.isArray(periods) && periods.length > 0) {
			if (weekday == 0) {
				weekday++;
			}
			periods = periods.filter((i) => {
				return i.open.day === weekday;
			});
			if (periods.length > 0) {
				let a = [{ weekday: 'long' }, { timeStyle: 'short' }];

				periods = joinDate(new Date(periods[0].open.nextDate), a, ' at ');

				statusText = `Reopens on ${periods}`;
			}
		}
	}

	return `<span class="location-status ${statusClass}">${statusText}</span>`;
}

function placeName(place, tag = 'h4') {
	let name = place.name;

	if (place.address_components) {
		let area = place.address_components.at(1);
		name = area.short_name;
	}
	// if(place.vicinity){
	// 	name = place.vicinity
	// }

	name = `<${tag} class="location-title">${name}</${tag}>`;

	return name;
}
/**
 *
 *
 * @param {google.maps.places.PlaceResult} place
 */
function placePhone(place) {
	let phone = '';
	if (place.international_phone_number || place.formatted_phone_number) {
		phone = place.formatted_phone_number;
		if (!phone) {
			phone = place.international_phone_number;
		}

		phone = `<a href="tel:${encodeURIComponent(
			place.international_phone_number
		)}" class="location-phone">${phone}</a>`;
	}
	return phone;
}

function placeAddress(place) {
	let address = '';
	let line1 = [];
	let line2 = [];

	let components = place.address_components;
	components.forEach((element) => {
		let type = element.types;
		if (type.includes('street_number') || type.includes('route')) {
			line1.push(element.short_name);
		} else if (type.includes('locality')) {
			line2.push(element.short_name + ',');
		} else if (type.includes('administrative_area_level_1') || type.includes('postal_code')) {
			line2.push(element.short_name);
		}
	});

	line1 = `<span class="line-1">${line1.join(' ')}</span>`;
	line2 = `<span class="line-2">${line2.join(' ')}</span>`;

	address = `<address class="location-address">${line1}${line2}</address>`;

	return address;
}
function placeHours(place) {
	let hours = place.opening_hours.weekday_text;

	let hoursList = [];
	hours.forEach((hour) => {
		hoursList.push(`<li>${hour}</li>`);
	});

	return `<ul class="location-hours list-unstyled">${hoursList.join('')}</ul>`;
}
function placeServices() {
	let services = [
		'Banking Center',
		'Night Deposit',
		'Drive Thru',
		'Foreign Currency Exchange',
		'ATM',
		'Instant Issue Debit Card',
		'Coin Counter',
		'Notary Service',
		'Extended Hours',
		'Safe Deposit Boxes',
	];
	let servicesList = [];
	services.forEach((service) => {
		servicesList.push(`<li>${service}</li>`);
	});

	return `<ul class="location-services list-unstyled">${servicesList.join('')}</ul>`;
}

/**
 * Generate Place List Item
 *
 * @param {number} i  - List number order
 * @param {google.maps.places.PlaceResult} place
 * @param {HTMLElement} parent
 * @param {google.maps.Map} map
 * @param {google.maps.LatLngBounds} bounds
 * @param {google.maps.Symbol} svgMarker
 */
function placeListItem(i, place, parent, map, bounds, svgMarker) {
	let name = placeName(place, 'h4'),
		phone = placePhone(place),
		address = placeAddress(place),
		status = placeStatus(place),
		view = `<button data-location='${JSON.stringify(
			place.geometry.location.toJSON()
		)}' class="view-location btn btn-link"><span class="btn-text">View On Map</span></button>`,
		services = `<button data-location='${JSON.stringify(
			place.geometry.location.toJSON()
		)}' class="view-services btn btn-link"><span class="btn-text">Services & Hours</span><span class="btn-icon icon-right"><i class="bi bi-info-circle-fill"></i></span></button>`;

	const position = place.geometry.location;

	/** @type {google.maps.MarkerLabel} */
	const label = {
		color: '#ff5b00',
		text: `${parseInt(i) + 1}`,
		fontFamily: 'Poppins',
		className: 'marker-icon',
		fontWeight: '500',
	};
	const marker = new google.maps.Marker({
		map,
		icon: svgMarker,
		title: place.vicinity,
		label,
		position: place.geometry.location,
		// animation: google.maps.Animation.DROP,

		// origin: new google.maps.Point(0, 0),
		// anchor: new google.maps.Point(17, 34),
		// scaledSize: new google.maps.Size(25, 25),
	});

	markers.push(marker);

	let inner = [name, address, phone, view, status];

	inner = appendChildren('<div class="location-inner"></div>', inner);

	let outer = appendChildren('<div class="location-outer"></div>', [inner, services]);

	outer = appendChildren('<li class="location-list-item"></li>', [outer]);

	if (isElement(outer)) {
		parent.appendChild(outer);
	}

	let viewLocation = outer.querySelector('.view-location');

	if (!isEmpty(viewLocation)) {
		viewLocation.addEventListener('click', () => {
			map.setCenter(position);
		});
	}

	let viewServices = outer.querySelector('.view-services');
	if (!isEmpty(viewServices)) {
		let grandparent = document.getElementById('locations');

		viewServices.addEventListener('click', () => {
			placePanel(place, grandparent, map, bounds, marker);
			map.setCenter(position);
		});
	}
}

function paginate(arr, size) {
	return arr.reduce((acc, val, i) => {
		let idx = Math.floor(i / size);
		let page = acc[idx] || (acc[idx] = []);
		page.push(val);

		return acc;
	}, []);
}

/**
 *
 *
 * @param {google.maps.places.PlaceResult} place
 * @param {HTMLElement} parent
 * @param {google.maps.map} map
 * @param {google.maps.LatLngBounds} bounds
 * @param {google.maps.Marker} marker
 */
function placePanel(place, parent, map, bounds, marker) {
	let name = placeName(place, 'h3'),
		phone = `<div class="phone">Call: ${placePhone(place)}</div>`,
		address = placeAddress(place),
		status = placeStatus(place),
		view =
			'<button class="close btn btn-link"><span class="btn-text visually-hidden">Close Panel</span><span class="btn-icon"><i class="bi bi-x-lg"></i></span></button>',
		hours = `<div class="panel-section hours flex-wrap flex-md-nowrap hstack gap-3"><div><h5>Lobby</h5>${placeHours(
			place
		)}</div><div><h5>Drive Thru</h5>${placeHours(place)}</div></div>`,
		services = `<div class="panel-section">${placeServices()}</div>`;
	for (var i = 0; i < markers.length; i++) {
		markers[i].setMap(null);
	}
	let inner = [
		view,
		`<div class="panel-section">${name}${address}${phone}${status}</div>`,
		'<h4 class="bg-light">Hours</h4>',
		hours,
		'<h4 class="bg-light">Services</h4>',
		services,
	];

	let outer = appendChildren('<div class="location-panel"></div>', inner);

	if (isElement(outer)) {
		parent.appendChild(outer);
		parent.classList.add('panel-active');
		marker.setMap(map);
		let placebounds = new google.maps.LatLngBounds();
		if (place.geometry.viewport) {
			// Only geocodes have viewport.
			placebounds.union(place.geometry.viewport);
		} else {
			placebounds.extend(place.geometry.location);
		}
		map.fitBounds(placebounds);
	}

	let viewServices = outer.querySelector('.close');
	if (!isEmpty(viewServices)) {
		viewServices.addEventListener('click', () => {
			markers.forEach((marker) => {
				marker.setMap(map);
			});

			parent.classList.remove('panel-active');
			outer.remove();
			map.fitBounds(bounds);
		});
	}
}
export default {
	init() {
		// JavaScript to be fired on the locations page
		initMap();
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
		const myCollapsible = document.getElementById('filter-dropdown');
		myCollapsible.addEventListener('show.bs.collapse', () => {
			document.getElementById('locations').classList.add('filters-open');
		});
		myCollapsible.addEventListener('hide.bs.collapse', () => {
			document.getElementById('locations').classList.remove('filters-open');
		});
	},
	resize() {},
};
